import { BFFAgent } from 'BFFAgent'
import { put, call } from 'redux-saga/effects'
import {
  TAKING_CAR_SALE_UPDATE_COMMENT_SUCCESS,
  TAKING_CAR_SALE_UPDATE_COMMENT_FAILURE
} from '../constants'

export function* updateCommentSaga({
  data: { id, comment }
}) {
  try {
    const response = yield call(
      BFFAgent.Stock.TakingCarManagement.updateComment,
      id,
      comment
    )

    if (response) {
      yield put({
        type: TAKING_CAR_SALE_UPDATE_COMMENT_SUCCESS,
      })
    }
  } catch (error) {
    yield put({
      type: TAKING_CAR_SALE_UPDATE_COMMENT_FAILURE,
    })
  }
}
